import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledContainer = styled.div`
  display: flex;
  width: 95px;
  flex-direction: column;
  align-items: center;
  margin: auto auto 16px auto;

  & > :first-of-type {
    margin-bottom: 8px;
  }

  & > :last-child {
    width: 100%;
    min-height: 32px;
    margin-bottom: 8px;
    text-align: center;
    word-wrap: break-word;
  }
`

export const StyledImage = styled.div`
  display: flex;
  overflow: hidden;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.primary50};
  border-radius: 50%;

  & > img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
`

export const StyledCaption = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  color: ${theme.colors.gray600};
  font-size: 12px;
  font-weight: 600;
  -webkit-line-clamp: 2;
  line-height: 16px;
  text-decoration: none;
  text-overflow: ellipsis;
`
export const StyledItemImageContain = styled.span`
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
`
